import { ViewModel,View } from "binder"
import  { ImageView } from "./image-view"
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ImagePropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { PropertyType } from "src/formBuilder/datamodel/structure";


export class ImageComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Image';
        this.canAcceptContent = false;
        this.canAcceptMultipleContent = false;

        this.addProperty("Source","data-b-style-background-image",new ImagePropertyType(this),null,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    protected getClassDefaultValue(){
        return "";
    }

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ImageElement(parent);
        return result;
    }
        
}
export class ImageElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ImageView();
    }
    public getTypeId(): string {
        return "VM-EDE72397-2681-44AA-BDEB-3D5666B6A5FB"
    }

    public set Source(v: string) { this._Source = v; } public get Source(): string { return this._Source;} private _Source: string;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitImage(this,parameter);
    }

}

